import styled from '@emotion/styled';
import { colors } from '@innovationdepartment/proxima-ui';
import { Link } from 'react-router';

export const BackLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  width: fit-content;
  padding-bottom: 12px;
  font-size: 14px;
  color: ${colors.neutral80};
  text-decoration: none;

  &:hover {
    color: ${colors.neutral100};
    text-decoration: underline;
  }
`;
